import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { connect } from 'react-redux';


const Options  = props => {
  const { dispatch, selectedOptions, set, validationMode } = props;
  const prepareOptionsStyle = (optType, optVal) => {
    let baseStyle = { fontSize: '12px', padding: '6px', border: '1px solid transparent' };
    if (selectedOptions[optType] && selectedOptions[optType] === optVal ) {
      return { ...baseStyle, border: '1px solid #f44336', borderRadius: '8px' }
    }
    return baseStyle;
  }
  return (
    <div style={{display: 'flex', flexDirection: 'column', width: '90%', marginTop: '4px', marginBottom: '12px'}}>
      {
        Object.keys(set.options).map( key => {
          const optionValues = set.options[key];
          const optionsValuesKeys = Object.keys(optionValues);
          return (
            <div key={key}>
              {validationMode && !selectedOptions[key] &&
                <div style={{color: '#f44336', fontSize: '12px'}}>Необходимо выбрать конфигурацию</div>
              }
              <div style={{fontSize: '12px', color: '#555', marginBottom: '8px', marginTop: '8px'}}>{key}</div>
              {
                optionsValuesKeys.map( valKey => {
                  return (
                    <FlatButton
                      key={valKey}
                      label={optionValues[valKey]}
                      labelStyle={prepareOptionsStyle(key, valKey)}
                      hoverColor='transparent'
                      onClick={
                        () => {
                          dispatch({
                            type: 'SET_SELECTED_OPTIONS',
                            p: { [key]: valKey }
                          })
                        }
                      }
                    ></FlatButton>
                  )
                })
              }
            </div>
          )
        })
      }
    </div>
  );
}

export default connect(
  state => ({ selectedOptions: state.ui.orderConditions.selectedOptions })
)(Options);



// WEBPACK FOOTER //
// ./src/components/layout/content/prepare-order/options.js